export default "__VITE_PUBLIC_ASSET__2e8ee154__"